require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./v-liga-de-campeones-comienza-la-batalla-en-europa-para-destronar-al-poderoso-real-madrid.json") })
        }
      }, "path---v-liga-de-campeones-comienza-la-batalla-en-europa-para-destronar-al-poderoso-real-madrid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---v-liga-de-campeones-comienza-la-batalla-en-europa-para-destronar-al-poderoso-real-madrid!./.cache/json/v-liga-de-campeones-comienza-la-batalla-en-europa-para-destronar-al-poderoso-real-madrid.json
// module id = 457
// module chunks = 231608221292675